var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnselectedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11 0C14.3137 0 17 2.68629 17 6V9C17 9.34459 16.9689 9.68204 16.9131 10.0107C17.4911 10.2317 18.0829 10.4833 18.6914 10.7676C20.7891 11.7476 21.9999 13.9405 22 16.2559V22.3369C22 25.8144 19.2691 28.6538 15.835 28.8281L15.5 28.8369H6.5L6.16504 28.8281C2.73089 28.6538 3.39211e-05 25.8144 0 22.3369V16.3242C0 14.0461 1.17374 11.8925 3.19141 10.8711L3.38965 10.7754C3.97253 10.5089 4.53986 10.2696 5.09473 10.0576C5.05115 9.81266 5.02069 9.56287 5.00781 9.30859L5 9V6C5 2.68629 7.68629 0 11 0ZM15.9883 12.333C14.9119 13.9408 13.0801 15 11 15C8.93728 15 7.11895 13.9582 6.03906 12.373C5.52362 12.5685 4.98811 12.7931 4.42871 13.0488C3.29394 13.5677 2.5 14.8189 2.5 16.3242V22.3369C2.50004 24.546 4.29088 26.3369 6.5 26.3369H15.5C17.7091 26.3369 19.5 24.546 19.5 22.3369V16.2559C19.4999 14.7687 18.7293 13.5441 17.6338 13.0322C17.0619 12.765 16.5146 12.5331 15.9883 12.333ZM11 2.5C9.067 2.5 7.5 4.067 7.5 6V9C7.5 10.933 9.067 12.5 11 12.5C12.933 12.5 14.5 10.933 14.5 9V6C14.5 4.067 12.933 2.5 11 2.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedList);
export default __webpack_public_path__ + "static/media/unselected-list.0853d37d112c87b9305977327fe4bb74.svg";
export { ForwardRef as ReactComponent };